import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AccountBlockedResult, AccountPagedResult, CheckRemovalAccountResult, GetRemovalAccount, GetRemovalAccountResult, GetRemovalsAccountResult } from '../model/account.model';
import { headersBase } from '../../../../helper/headerBase';

@Injectable()
export class AccountServiceRest {
  constructor(
    private http: HttpClient
  ) {
  }

  public getAccounts(page: number, pageSize: number, search: string, accountBlockedSelected: boolean, accountSuspectedFraudSelected: boolean, accountDeletedSelected: number): Observable<AccountPagedResult> {
    var param = "";
    if (accountBlockedSelected != null) {
      param += `&accountBlocked=${accountBlockedSelected}`;
    }
    if (accountSuspectedFraudSelected != null) {
      param += `&accountSuspectedFraud=${accountSuspectedFraudSelected}`;
    }
    if (accountDeletedSelected != null) {
      param += `&accountRemovalStatus=${accountDeletedSelected}`;
    }

    return this.http.get<AccountPagedResult>(`Account?page=${page}&pageSize=${pageSize}&search=${search}${param}`, headersBase() );
  }

  public checkRemovalAccount(): Observable<CheckRemovalAccountResult> {
    return this.http.get<CheckRemovalAccountResult>(`Account/CheckRemovalAccount`, headersBase() );
  }

  public getRemovalAccountResult(accountId: string): Observable<GetRemovalsAccountResult> {
    return this.http.get<GetRemovalsAccountResult>(`Account/getRemovalAccount/${accountId}`, headersBase() );
  }

  public updateStatus(payload: GetRemovalAccount): Observable<GetRemovalAccountResult> {
    return this.http.put<GetRemovalAccountResult>(`Account/updateStatus`, payload, headersBase());
  }
  
  public putAccountBlocked(accountId: string, changeTo: boolean): Observable<AccountBlockedResult> {
  return this.http.put<AccountBlockedResult>(`Account/${accountId}/blocked?changeTo=${changeTo}`, null, headersBase());
  }

  public putDeviceBlocked(accountId: string, deviceId: string, changeTo: boolean): Observable<AccountBlockedResult> {
    return this.http.put<AccountBlockedResult>(`Account/${accountId}/device/${deviceId}/blocked?changeTo=${changeTo}`, null, headersBase());
  }
}

